export default (employees) => {
  let firstWorkShift = {}
  let secondWorkShift = {}

  for (let employee in employees) {
    if (Number(employees[employee].workShift) === 1) {
      firstWorkShift[employee] = employees[employee]
    }
    if (Number(employees[employee].workShift) === 2) {
      secondWorkShift[employee] = employees[employee]
    }
  }

  return { firstWorkShift, secondWorkShift }
}